<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Create single panel claim" @close="onClose")

      yz-dialog-normal-content.px-6.py-6
        .text-neutral-700
          .yz-medium-body-md.mb-4 Are you sure you want to create a single panel claim?
          .yz-regular-body-sm.mb-4 This panel is set up for bulk panel claims. If you continue, this invoice will be created as a single panel claim.
          .yz-regular-body-sm Click "Confirm" to proceed.

      yz-dialog-normal-actions
        .d-flex.align-center.gap-3.justify-end
          yz-btn(size="lg" text, label="Cancel" @click="onCancel")
          yz-btn(size="lg" label="Confirm" color="primary" @click="onConfirm")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirmed')
      this.onClose()
    },
    onCancel() {
      this.$emit('canceled')
      this.onClose()
    },
    onClose() {
      this.showDialog = false
    }
  }
}
</script>

<style scoped>
</style>